import { StudyObjectGroupCompareEnum } from '../configs/StudiesObjectsCompareGroupTypesConfig'
import ClilInputAutoCompletion from './clil/ClilInputAutoCompletion'
import TitleInputAutoCompletion from './titles/TitleInputAutoCompletion'
import AuthorInputAutoCompletion from './authors/AuthorInputAutoCompletion'
import { AuthorInterface } from '../../../../../core/interface/author.interface'
import { BookSearchInterface } from '../../../../../core/interface/book-search.interface'
import { BookInterface } from '../../../../../core/interface/book.interface'
import AudienceFileMenu from './AudienceFileMenu'
import { DateFilterTypeEnum } from '../../../../../core/enums/date-filter-type.enum'
import NewReadershipProfileBookFiltersInterface from '../../../../../core/interface/analytics/new-readership-profile-book-filters'

const InputTypeSwitchInput = <InputType, ValueType>({
  disable,
  color,
  type,
  handleSelectValue,
  handleOnClickInputSelectionButton,
  inputValue,
  booksSelected,
  handleUpdateBooksSelected,
  handleOpenBookDetails,
  eanSelected,
  filtersActions,
  addInput,
  removeInput,
}: {
  disable: boolean
  color: string
  type: StudyObjectGroupCompareEnum
  inputValue: ValueType
  handleSelectValue: (value: ValueType) => void
  handleOnClickInputSelectionButton: (type: InputType) => void
  booksSelected: BookInterface[]
  handleUpdateBooksSelected: (books: BookInterface[]) => void
  handleOpenBookDetails: (eanId: number | null) => void
  eanSelected: number | null
  addInput: (id: string, editions: BookInterface[]) => void
  removeInput: (id: string) => void
  filtersActions?: NewReadershipProfileBookFiltersInterface
}) => {
  switch (type) {
    case StudyObjectGroupCompareEnum.CLIL:
      return (
        <ClilInputAutoCompletion
          color={color}
          disable={disable}
          inputValue={inputValue as string[]}
          handleSelectClil={(value: string[]) =>
            handleSelectValue(value as ValueType)
          }
        />
      )
    case StudyObjectGroupCompareEnum.TITLE:
      return (
        <TitleInputAutoCompletion
          disable={disable}
          color={color}
          inputValue={inputValue as BookSearchInterface[] | null}
          handleOnClickItemMenu={(value: BookSearchInterface[] | null) =>
            handleSelectValue(value as ValueType)
          }
          booksSelected={booksSelected}
          handleUpdateBooksSelected={handleUpdateBooksSelected}
          handleOpenBookDetails={handleOpenBookDetails}
          eanSelected={eanSelected}
          filtersActions={filtersActions}
          addInput={addInput}
          removeInput={removeInput}
        />
      )
    case StudyObjectGroupCompareEnum.AUTHOR:
      return (
        <AuthorInputAutoCompletion
          disable={disable}
          color={color}
          inputValue={inputValue as AuthorInterface[]}
          handleOnClickItem={(value: AuthorInterface[] | null) =>
            handleSelectValue(value as ValueType)
          }
          booksSelected={booksSelected}
          handleUpdateBooksSelected={handleUpdateBooksSelected}
          filtersActions={filtersActions}
          addInput={addInput}
          removeInput={removeInput}
        />
      )
    case StudyObjectGroupCompareEnum.USERS_LIST:
      return (
        <AudienceFileMenu
          inputValue={inputValue as File}
          handleRemove={() => {
            handleSelectValue(null as ValueType)
            handleOnClickInputSelectionButton(
              StudyObjectGroupCompareEnum.TITLE as InputType,
            )
          }}
        />
      )
    default:
      return null
  }
}

export default InputTypeSwitchInput
